import { AlignCenterHorizontal, AlignCenterVertical } from 'lucide-react';
import { ReactNode } from 'react';
import { toFiniteNumber } from 'shared/utils';
import { theme } from 'styles/theme/theme';
import Input, { IconWrapper } from '../../../elements/input';
import { Item, SubItem } from '../styles';
import AlignmentButton from './alignment-button';

export interface Position {
  x: number;
  y: number;
}

export interface Size {
  width: number;
  height: number;
}

interface TransformSectionProps {
  position: Position;
  size: Size;
  onChangePosition: (x: number, y: number) => void;
  onChangeSize: (width: number, height: number) => void;
  onAlignCenterHorizontal: () => void;
  onAlignCenterVertical: () => void;
  /** Вызывается при фокусе на любом поле секции — обычно фиксирует состояние в истории. */
  onFocusField?: () => void;
  /** Дополнительные кнопки после центрирования (отражение и т.п.). */
  alignmentExtra?: ReactNode;
  /** Поля после блока «Размер» — радиус, скруглённые углы и т.п. */
  children?: ReactNode;
}

/**
 * Общая секция правого тулбара: выравнивание по центру, координаты и размер
 * выбранного объекта. Каждый инспектор задаёт свои обработчики — способ
 * применить позицию и размер у текста, фигуры и плейсхолдера различается.
 */
function TransformSection(props: TransformSectionProps) {
  const {
    position,
    size,
    onChangePosition,
    onChangeSize,
    onAlignCenterHorizontal,
    onAlignCenterVertical,
    onFocusField,
    alignmentExtra,
    children,
  } = props;

  return (
    <Item>
      <SubItem style={{ width: '26%', justifyContent: 'space-between' }}>
        <AlignmentButton tooltip="По центру по горизонтали" onClick={onAlignCenterHorizontal}>
          <AlignCenterHorizontal size={18} color={theme.colors.EditorAccentBlue} />
        </AlignmentButton>
        <AlignmentButton tooltip="По центру по вертикали" onClick={onAlignCenterVertical}>
          <AlignCenterVertical size={18} color={theme.colors.EditorAccentBlue} />
        </AlignmentButton>
        {alignmentExtra}
      </SubItem>
      <SubItem>
        <span>Расположение</span>
        <Input
          numeric
          onFocus={onFocusField}
          style={{ width: 73 }}
          icon={<IconWrapper>X</IconWrapper>}
          value={position.x.toString()}
          onChange={(value) => onChangePosition(toFiniteNumber(value, position.x), position.y)}
        />
        <Input
          numeric
          onFocus={onFocusField}
          style={{ width: 73 }}
          icon={<IconWrapper>Y</IconWrapper>}
          value={position.y.toString()}
          onChange={(value) => onChangePosition(position.x, toFiniteNumber(value, position.y))}
        />
      </SubItem>
      <SubItem>
        <span>Размер</span>
        <Input
          numeric
          onFocus={onFocusField}
          icon={<IconWrapper>Ш</IconWrapper>}
          value={size.width.toString()}
          onChange={(value) => onChangeSize(toFiniteNumber(value, size.width), size.height)}
        />
        <Input
          numeric
          onFocus={onFocusField}
          icon={<IconWrapper>В</IconWrapper>}
          value={size.height.toString()}
          onChange={(value) => onChangeSize(size.width, toFiniteNumber(value, size.height))}
        />
      </SubItem>
      {children}
    </Item>
  );
}

export default TransformSection;
